import * as THREE from "three";
import { Context } from "../core/context";
import {
  DBEntity,
  DbLine,
  DbMesh,
  SceneManager,
  ViewManager,
} from "@/CadEngine";
import {
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
  IModifyOperation,
  ModifyOperateState,
} from "./IModifyOperation";
import { LineDimension } from "@/Dimensions/LineDimension";
import { ArcDimension } from "@/Dimensions/ArcDimension";
import { AnchorPointAux } from "@/Dimensions/AnchorPointAuxs";
import { OrthogonalAux } from "@/Dimensions/OrthogonalAux";
import { CircleAnchorPointAuxs } from "@/Dimensions/CircleAnchorPointAuxs";
import { IndsertPosition } from "@/core/IndserObject";
import { EditAssistModel, EditAssistModelType } from "@/core/EditAssistModel";
import { CommonColor, Linearity } from "@/core/Parameters";
import { ULabel } from "@/ui/ULabel";
import { DimensionGroup } from "@/core/DimensionGroup";

class EditModify implements IModifyOperation {
  private m_context: Context;
  private points: THREE.Vector3[] = [];
  private curPoint: THREE.Vector3 = new THREE.Vector3();
  private AuxLine: THREE.Line | undefined;
  public get Points() {
    return this.points;
  }
  private m_dimension: DimensionGroup;
  private m_locationObject: THREE.Line;
  private curInputLength: string = "";
  private m_editAssistModel: EditAssistModel;
  private m_selects: DbLine[] = [];
  private m_ray: THREE.Ray;
  private m_activeEditAssistModels: THREE.Mesh[] = [];
  private m_tempModels: THREE.LineSegments[] = [];
  private m_handleSwitch: boolean = false;
  private m_activePoint: THREE.Vector3 | undefined = undefined;
  private m_scale: number = 1;
  private m_sourceSelect: DbLine[] = [];
  private m_isEdit: boolean = false;

  constructor(context: Context) {
    this.m_context = context;
    this.m_dimension = new DimensionGroup(
      context.ViewManager,
      context.SceneManager.AuxModel
    );
    this.m_locationObject = context.ToolsManager.CreatedLocationLine();

    this.m_dimension.Line.SetVaule("");
    this.m_dimension.Line.Input.Dom.style.border = "2px solid #fff";
    this.m_editAssistModel = new EditAssistModel(context);
    // this.stipulateLayerNames = acceptParams.stipulateLayerNames;
    this.m_ray = this.m_context.SelectionManager.CameraRay.ray;
    this.m_selects = this.m_context.SelectionManager.GetSelected() as DbLine[];
    this.m_selects.forEach((item) => {
      this.m_editAssistModel.Create(item);
      this.m_sourceSelect.push(DbLine.clone(item));
    });
  }

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(point: DrawOperationMovePointParams): void {
    this.curPoint = point.point;
    this.m_locationObject.position.copy(this.curPoint);
    if (this.m_editAssistModel.EditAssistModelGroup) {
      this.m_editAssistModel.EditAssistModelGroup.traverse(
        (obj: THREE.Object3D) => {
          if (obj instanceof THREE.Mesh) {
            if (this.m_ray.intersectsSphere(obj.geometry.boundingSphere)) {
              this.m_locationObject.position.copy(
                obj.geometry.boundingSphere.center
              );
              this.curPoint.copy(obj.geometry.boundingSphere.center);
            }
          }
        }
      );
      if (this.m_activePoint) {
        this.m_isEdit = true;
        this.m_dimension.Line.Input.Visibility = true;
        this.m_dimension.Line.SetDimension(
          this.m_activePoint,
          this.curPoint,
          this.scale
        );
        this.curInputLength = "";
      } else {
        this.m_dimension.Line.SetDimension(
          new THREE.Vector3(),
          new THREE.Vector3(),
          0
        );
        this.m_dimension.Line.Input.Visibility = false;
      }
    }
  }
  OnDownPoint(point: DrawOperationMovePointParams): void {
    this.m_handleSwitch = true;
    this.updatedModel();
    this.m_context.SelectionManager.ClearSelected();
    this.m_context.SelectionManager.SetSelected(...this.m_selects);
    this.m_activeEditAssistModels = [];
    this.m_tempModels = [];
    if (this.m_editAssistModel.EditAssistModelGroup && this.m_handleSwitch) {
      for (
        let i = 0;
        i < this.m_editAssistModel.EditAssistModelGroup.children.length;
        i++
      ) {
        const EditAssistModel =
          this.m_editAssistModel.EditAssistModelGroup.children[i];
        let res = this.m_editAssistModel.UpdatedModelMaterialByPoint(
          EditAssistModel as THREE.Mesh,
          point.point
        );
        if (res) {
          this.m_activePoint = point.point;
          this.m_activeEditAssistModels.push(EditAssistModel as THREE.Mesh);
          this.createTempModel(EditAssistModel.userData.originData);
        }
      }
      this.createdAuxLineAux();
    }
  }
  onKeyDown(e: KeyboardEvent): void {
    e.preventDefault();
    if (e.key == "Backspace") {
      this.curInputLength = this.curInputLength.substring(
        0,
        this.curInputLength.length - 1
      );
      this.m_dimension.Line.SetVaule(this.curInputLength);
    } else if ((e.key >= "0" && e.key <= "9") || e.key == ".") {
      if (this.curInputLength?.includes(".") && e.key == ".") return;
      this.curInputLength += e.key;
      this.m_dimension.Line.SetVaule(this.curInputLength);
    } else if (e.key == "Enter") {
      if (this.m_activePoint) {
        if (this.curInputLength == "") {
          this.curInputLength = (
            this.m_activePoint.distanceTo(this.curPoint) * 1000
          ).toString();
        }
        let length = parseFloat(this.curInputLength) * 0.001;
        let curVectorNor = new THREE.Vector3()
          .subVectors(this.curPoint, this.m_activePoint)
          .normalize();
        curVectorNor.setLength(length);
        this.curPoint = this.m_activePoint.clone().add(curVectorNor);
        this.onMouseMove();
        this.OnDownPoint({
          point: this.curPoint,
          geo: undefined,
          position: IndsertPosition.None,
        });
      }
    }
  }
  onKeyUp(e: KeyboardEvent): void {}

  OnZoom(camera: THREE.Camera): void {}

  Finish(operate: ModifyOperateState) {
    this.clear();
    if (operate == ModifyOperateState.complete) {
      if (!this.m_isEdit) {
        return {
          updateData: [],
          sourceData: [],
        };
      } else {
        return {
          updateData: this.m_selects,
          sourceData: this.m_sourceSelect,
        };
      }
    } else if (operate == ModifyOperateState.cancel) {
      return [];
    }
  }
  OnWheel(e: WheelEvent): void {
    let scale = this.scale * 10;
    if (this.m_editAssistModel.EditAssistModelGroup) {
      this.m_editAssistModel.EditAssistModelGroup.traverse(
        (obj: THREE.Object3D) => {
          if (obj instanceof THREE.Mesh) {
            this.m_editAssistModel.UpdatedModelByScale(obj, scale);
          }
        }
      );
    }
  }

  onMouseMove(e?: PointerEvent): void {
    if (this.m_activeEditAssistModels.length && this.m_tempModels.length) {
      for (let i = 0; i < this.m_activeEditAssistModels.length; i++) {
        let activeEditAssistModel = this.m_activeEditAssistModels[i];
        let { originData } = activeEditAssistModel.userData;
        let position = [...activeEditAssistModel.userData.originData.points];
        let auxLinePoints: number[] = [];
        switch (activeEditAssistModel.userData.type) {
          case EditAssistModelType.START:
            auxLinePoints = [
              position[0],
              position[1],
              0,
              this.curPoint.x,
              this.curPoint.y,
              0,
            ];
            (position[0] = this.curPoint.x), (position[1] = this.curPoint.y);
            break;
          case EditAssistModelType.END:
            auxLinePoints = [
              position[position.length - 3],
              position[position.length - 2],
              0,
              this.curPoint.x,
              this.curPoint.y,
              0,
            ];
            (position[position.length - 3] = this.curPoint.x),
              (position[position.length - 2] = this.curPoint.y);
            break;
          case EditAssistModelType.MID:
            let startP = new THREE.Vector3(position[0], position[1], 0);
            let endP = new THREE.Vector3(
              position[position.length - 3],
              position[position.length - 2],
              0
            );
            let midP = new THREE.Vector3().lerpVectors(startP, endP, 0.5);
            auxLinePoints = [
              midP.x,
              midP.y,
              0,
              this.curPoint.x,
              this.curPoint.y,
              0,
            ];
            let cToMVector = new THREE.Vector3().subVectors(
              this.curPoint,
              midP
            );
            let newStartP = new THREE.Vector3().addVectors(startP, cToMVector);
            let newEndP = new THREE.Vector3().addVectors(endP, cToMVector);
            // position = [newStartP.x, newStartP.y, 0, newEndP.x, newEndP.y, 0];
            position[0] = newStartP.x;
            position[1] = newStartP.y;
            position[position.length - 3] = newEndP.x;
            position[position.length - 2] = newEndP.y;
        }
        let selectLayerLineTypeName =
          this.m_context.ToolsManager.GetLayerLineTypeName(originData);
        if (selectLayerLineTypeName == Linearity.Dash) {
          let startP = new THREE.Vector3(position[0], position[1], 0);
          let endP = new THREE.Vector3(
            position[position.length - 3],
            position[position.length - 2],
            0
          );
          let dashPoints =
            this.m_context.ToolsManager.PassStartAndEndPointGetDashPoints(
              startP,
              endP
            );
          let index = 0;
          let indexes: number[] = [];
          position = dashPoints.flatMap((point) => {
            indexes.push(index);
            index++;
            return [point.x, point.y, point.z];
          });
          originData.indexes = new Int32Array(indexes);
        }
        this.m_tempModels[i].geometry.setAttribute(
          "position",
          new THREE.BufferAttribute(new Float32Array(position), 3)
        );

        this.AuxLine?.geometry.setAttribute(
          "position",
          new THREE.BufferAttribute(new Float32Array(auxLinePoints), 3)
        );
        this.AuxLine?.computeLineDistances();
        this.m_context.SelectionManager.EnableSnap(true);
      }
    }
  }

  onMouseDown(e: PointerEvent): void {
    if (e.button !== 0) return;
  }

  onMouseUp(e: PointerEvent): void {
    if (e.button !== 0) return;
    this.m_context.SelectionManager.ClearSelected();
    this.m_context.SelectionManager.SetSelected(...this.m_selects);
  }

  private get scale() {
    return this.m_context.ViewManager.ScreenModelScale;
  }

  private createTempModel(dbline: DbLine) {
    let mkey = dbline.layerId + "_" + dbline.color;
    let mMaterial = null;
    for (const key in this.m_context.ModelManager.Lines) {
      if (mkey == key) {
        mMaterial = (
          this.m_context.ModelManager.Lines[key].model
            .material as THREE.LineBasicMaterial
        ).clone();
      }
    }

    let geometry = new THREE.BufferGeometry();
    let positions = new THREE.BufferAttribute(
      new Float32Array([...dbline.points]),
      3
    );
    geometry.setAttribute("position", positions);
    if (mMaterial) {
      let mLineSegment = new THREE.LineSegments(geometry, mMaterial);
      mLineSegment.frustumCulled = false;
      this.m_context.SceneManager.AuxModel.add(mLineSegment);
      this.m_tempModels.push(mLineSegment);
    }
  }
  private createdAuxLineAux() {
    this.AuxLine = this.m_context.ToolsManager.CreatedAuxLine();
    this.AuxLine.name = "AuxLine";
    this.AuxLine.frustumCulled = false;
    this.m_context.SceneManager.AuxModel.add(this.AuxLine);
  }
  private updatedModel() {
    if (this.m_tempModels.length && this.m_activeEditAssistModels.length) {
      this.m_editAssistModel.Dispose();
      this.m_context.ToolsManager.ObjectsClear([this.AuxLine!]);
      this.AuxLine = undefined;
      this.m_activePoint = undefined;
      for (let i = 0; i < this.m_tempModels.length; i++) {
        let tempModel = this.m_tempModels[i];
        let newPosition = tempModel.geometry.attributes.position.array;
        let activeDbLine = this.m_activeEditAssistModels[i].userData.originData;
        activeDbLine.points = newPosition;
        this.m_context.ToolsManager.ObjectsClear([tempModel]);
      }
      this.m_context.ModelManager.ByDatasUpdateModel(this.m_selects);

      this.m_context.ViewManager.Render();

      for (let i = 0; i < this.m_selects.length; i++) {
        const dbline = this.m_selects[i];
        this.m_editAssistModel.Create(dbline);
      }
      this.m_handleSwitch = false;
      this.m_context.SelectionManager.EnableSnap(false);
    }
  }
  private clear() {
    this.m_context.ToolsManager.ObjectsClear([
      this.m_locationObject,
      this.AuxLine!,
    ]);
    this.m_dimension?.dispose();
    this.m_editAssistModel.Dispose();
    for (let i = 0; i < this.m_tempModels.length; i++) {
      this.m_tempModels[i].removeFromParent();
      this.m_tempModels[i].geometry.dispose();
      (this.m_tempModels[i].material as THREE.LineBasicMaterial).dispose();
    }
  }
}

export { EditModify };
